import React from 'react';
import { Mail, Phone } from 'lucide-react';
import MobileTitleSpacer from '../components/MobileTitleSpacer';
import SEO from '../components/SEO';
import { seoConfig } from '../utils/seoConfig';

const Contact = () => {
  return (
    <>
      <SEO 
        title={seoConfig.contact.title}
        description={seoConfig.contact.description}
        keywords={seoConfig.contact.keywords}
        url={seoConfig.contact.url}
      />
      <div className="min-h-screen bg-black pt-20">
        {/* Header */}
        <div className="relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-30"
          style={{
            background: 'radial-gradient(circle at 30% 50%, rgba(0, 200, 220, 0.25) 0%, transparent 70%)',
          }}
        />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 md:py-20">
          <MobileTitleSpacer height="60px" />

          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white mb-4"
            style={{ color: 'rgba(123, 174, 236, 1)' }}
          >
            CONTACT
          </h1>

          <div
            className="h-1 w-32 md:w-40 mb-6"
            style={{ background: 'linear-gradient(to right, #00D0DF, transparent)' }}
          />

          <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl">
            Contactez-moi pour discuter de vos besoins en composition, prise de son
            ou post-production audio.
          </p>
        </div>
      </div>

      {/* Infos de contact */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 md:pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12">

          {/* Coordonnées */}
          <div
            className="rounded-2xl p-6 sm:p-8 border-2"
            style={{
              background: 'linear-gradient(135deg, rgba(0, 224, 255, 0.10) 0%, rgba(0, 0, 0, 0.90) 100%)',
              borderColor: 'rgba(0, 224, 255, 0.35)',
            }}
          >
            <h3 className="text-white text-xl sm:text-2xl font-bold mb-6 text-center">
              Me Contacter
            </h3>

            <div className="flex flex-col gap-6 text-center break-words">

              {/* EMAIL — OUVERTURE GMAIL */}
              <div className="flex flex-col items-center gap-2 px-2">
                <Mail className="text-cyan-400" size={28} />

                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=charlesludig.compositeur@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-cyan-300 hover:text-cyan-200 transition-colors text-xs sm:text-lg break-all"
                  style={{ wordBreak: 'break-all' }}
                >
                  charlesludig.compositeur@gmail.com
                </a>
              </div>

              {/* TÉLÉPHONE */}
              <div className="flex flex-col items-center gap-2 px-2">
                <Phone className="text-cyan-400" size={28} />
                <a
                  href="tel:+33632263177"
                  className="text-cyan-300 hover:text-cyan-200 transition-colors text-sm sm:text-lg"
                >
                  06 32 26 31 77
                </a>
              </div>

            </div>
          </div>

          {/* Réseaux sociaux */}
          <div
            className="rounded-2xl p-8 border-2"
            style={{
              background: 'linear-gradient(135deg, rgba(0, 224, 255, 0.10) 0%, rgba(0, 0, 0, 0.90) 100%)',
              borderColor: 'rgba(0, 224, 255, 0.35)',
            }}
          >
            <h3 className="text-white text-2xl font-bold mb-6 text-center">Suivez-moi</h3>

            <div className="flex flex-wrap justify-center gap-6 sm:gap-8">
              {[
                { name: 'Instagram', url: 'https://instagram.com/charlesludig', img: '/images/social/instagram.png' },
                { name: 'TikTok', url: 'https://tiktok.com/@charlesludig', img: '/images/social/tiktok.png' },
                { name: 'Facebook', url: 'https://facebook.com/charlesludig', img: '/images/social/facebook.png' },
                { name: 'YouTube', url: 'https://youtube.com/@charlesludig', img: '/images/social/youtube.png' },
                { name: 'LinkedIn', url: 'https://linkedin.com/in/charlesludig', img: '/images/social/linkedin.png' },
              ].map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-col items-center gap-2 group w-16 sm:w-20"
                >
                  <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl flex items-center justify-center 
                                  bg-black/30 backdrop-blur border border-white/10 
                                  shadow-[0_0_25px_rgba(0,224,255,0.15)] 
                                  transition-transform duration-300 hover:scale-105">
                    <img
                      src={social.img}
                      alt={social.name}
                      className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
                    />
                  </div>
                  <span className="text-white text-xs font-semibold">{social.name}</span>
                </a>
              ))}
            </div>
          </div>

        </div>
      </div>
      </div>
    </>
  );
};

export default Contact;
